export default "768a6fd5bea4585e.png"